import React, { useCallback, useContext} from "react"
import styled from "@emotion/styled"
import { AppContext } from '../../context'
import { HudIconButton } from "../molecules/hudButton";
import { IconType } from "../atoms/icon";

const Container = styled.div`
    display: flex;
    justify-content: center;    
    gap: 16px;
`
export default () => {
    const { disableControlsForSinglePage, audio, playingVideo, setZoomDelta, zoom, pageStep, selection, allowZoomIn, allowZoomOut, modeSelection } = useContext(AppContext);

    const onZoomInClick = useCallback(e => {
        e.stopPropagation();
        setZoomDelta({ delta: zoom.step, center: true });
    }, [zoom, setZoomDelta]);

    const onZoomOutClick = useCallback(e => {
        e.stopPropagation();
        setZoomDelta({ delta: -zoom.step, center: true });
    }, [zoom, setZoomDelta]);
    const shouldDisable = modeSelection || (disableControlsForSinglePage && pageStep === 1 && !selection)
    return playingVideo ? null : (
        <Container>
            <HudIconButton icon={IconType.zoomIn} onClick={onZoomInClick} disabled={!allowZoomIn || shouldDisable} audio={audio} />
            <HudIconButton icon={IconType.zoomOut} onClick={onZoomOutClick} disabled={!allowZoomOut || shouldDisable} audio={audio} />
        </Container>
    )
} 